<template>
  <div>
    <a-form :form="approveForm" @submit.prevent="handleApproveSubmit">
      <a-tabs :default-active-key="tabConfigIndex" @change="tabConfigClick" style="width: 100%">
        <a-tab-pane key="1" tab="配置信息">
          <a-row class="content-panle margin-0 padding-tb-0" >
            <a-col :span="12" class="padding-tb-md">
              <h3 class="panle-head" style="margin-bottom:16px">
                审批基本信息设置
              </h3>
              <!-- 中文名称 -->
              <a-col :span="24">
                <a-form-item label='审核类型'>
                  <a-radio-group @change="onApproveTypeChange"  v-decorator="['appointmentApplyExamineType',{
                   initialValue: 1,
                    rules: [{required: true,message: '审批类型不能为空'}]}]">
                    <a-radio :value="1">自主审核</a-radio>
                    <a-radio :value="2">流程审核</a-radio>
<!--                    <a-radio v-for="(item, index) in examineType" :key="index" :value="item.code">{{item.name}}</a-radio>-->
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <template v-if="approveType === 2">
                <a-col :span="24">
                  <a-form-item label='审核条件'>
                    <a-select
                      :getPopupContainer="trigger => trigger.parentNode"
                      placeholder="请选择审核条件"
                      @change="onExamineConditionChange"
                      v-decorator="[ 'appointmentApplyExamineCondition',{
                        rules: [ { required: approveType === 2, message: '审核条件不能为空' }],
                        validateTrigger: ['change', 'blur']
                      }]" >
                      <a-select-option v-for="(selector, index) in examineCondition" :key="index" :value="selector.code">
                        {{ selector.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item label='被拜访人匹配类型'>
                    <a-select
                      :getPopupContainer="trigger => trigger.parentNode"
                      placeholder="请选择被拜访人匹配类型"
                      v-decorator="[ 'appointmentApplyBeVisitedPersonMatchType',{
                        rules: [ { required: approveType === 2, message: '被拜访人匹配类型不能为空' }],
                      }]"
                    >
                      <a-select-option v-for="(selector, index) in beVisitedPersonMatchType" :key="index" :value="selector.value">
                        {{ selector.title }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="24" v-if="configParam.appointmentApplyExamineCondition == 3">
                  <a-form-item label='可自己审核人员'>
                    <a-select
                      :getPopupContainer="trigger => trigger.parentNode"
                      placeholder="请选择可自己审核人员"
                      mode="multiple"
                      v-decorator="[ 'appointmentApplySelfExaminePersonIds',{
                        rules: [ { required: false, message: $t('devicesManaConfig.activeTime.selectTimeConfigTxt') }]
                      }]" >
                      <a-select-option v-for="people in approvePeoples" :key="people.id" :value="people.id"  :label="people.name">
                        {{ people.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </template>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="2" tab="审批流程设置"  v-if="approveType === 2">
          <a-row class="content-panle margin-0 padding-tb-0" :gutter="24">
            <a-col :span="24" class="padding-tb-md">
              <h3 class="panle-head" style="margin-bottom:16px">
                审批流程设置
              </h3>
              <!-- 中文名称 -->
              <a-row justify="center" style="background-color: #efefef; padding: 30px 0; min-height: 327px; ">
                <a-col :span="24" :offset="8">
                  <div class="node-wrap-box">
                    <a-card size="small" title="流程开始" class="node-wrap-box-card" style="" :headStyle="headStyle"
                            :body-style="startBodyStyle">
                      <span>访客提交访问申请</span>
                    </a-card>
                    <div class="add-node-btn-box">
                      <div class="add-node-btn">
                        <a-popover placement="rightTop" :width="270" trigger="focus">
                          <a-button type="primary" shape="circle" icon="plus" size="large"/>
                          <template slot="content">
                            <div class="add-node-popover-body">
                              <ul>
                                <li>
                                  <a-icon type="user" style="color: #ff943e;" @click="addNode(1,0)"></a-icon>
                                  <p>审批节点</p></li>
<!--                                <li>-->
<!--                                  <a-icon style="color: #3296fa;" @click="addNode(2,0)" type="share-alt"/>-->
<!--                                  <p>抄送节点</p></li>-->
                              </ul>
                            </div>
                          </template>
                        </a-popover>
                      </div>
                    </div>
                  </div>
                </a-col>
                <template v-if="approveList.length>0">
                  <a-col :span="24" :offset="8" v-for="(item, index) in approveList" :key="index">
                    <div class="node-wrap-box">
                      <a-card size="small" :title="(item.type===1?'审核-' : '抄送-') + item.info.nodeName"
                              class="node-wrap-box-card" style=""
                              :headStyle="item.type===1?approveHeadStyle:copyHeadStyle"
                              :body-style="startBodyStyle" @click="handlePeopleSearchShow(item)">
                        <a-icon slot="extra" style="" type="close" class="close"
                                @click.stop="deleteConfig(item.info.id)"/>
                        <div>审核人：{{ getNames(item.info.examinePeople ) }}</div>
                        <div>抄送人：{{ getNames(item.info.ccPeople) }}</div>
                      </a-card>
                      <div class="add-node-btn-box">
                        <div class="add-node-btn">
                          <a-popover placement="rightTop" :width="270" trigger="focus">
                            <a-button type="primary" shape="circle" icon="plus" size="large"/>
                            <template slot="content">
                              <div class="add-node-popover-body">
                                <ul>
                                  <li>
                                    <a-icon type="user" style="color: #ff943e;" @click="addNode(1,0)"></a-icon>
                                    <p>审批节点</p></li>
<!--                                  <li>-->
<!--                                    <a-icon style="color: #3296fa;" @click="addNode(2,0)" type="share-alt"/>-->
<!--                                    <p>抄送节点</p></li>-->
                                </ul>
                              </div>
                            </template>
                          </a-popover>
                        </div>
                      </div>
                    </div>
                  </a-col>
                </template>
                <a-col :span="24" :offset="8">
                  <div style="width: 300px">
                    <div class="end-node">
                      <div class="end-node-circle"></div>
                      <div class="end-node-text">流程结束</div>
                      <div class="end-node-text">访客预约审核完成</div>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>
      <a-row class="content-panle margin-0 padding-tb-0" :gutter="24">
        <a-col :span="24" style="margin-top: 16px;">
          <a-button type="primary" html-type="submit" :loading="form1Submitting">
            {{ $t('userCenter.submitMiniProgSetBtn') }}
          </a-button>
        </a-col>
      </a-row>
    </a-form>
    <a-drawer
      width="400"
      placement="right"
      :visible="peopleSearchVisible"
      :title="selectType===1?'审批人':'抄送人'"
      :body-style="{ paddingBottom: '80px' }"
      @close="onPeopleSearchClose"
    >
      <div class="content-warp" style="top: 55px">
        <div class="content-panle bg-white">
          <a-tabs :default-active-key="tabIndex" @change="tabClick" style="width: 100%">
            <a-tab-pane key="1" tab="基本信息">
              <a-form :form="applyForm" ref="applyForm">
                <a-form-item label="" style="display: none">
                  <a-input v-decorator="['id', {rules:[{required: false}]}]"/>
                </a-form-item>
                <a-form-item label="名称" required>
                  <a-input v-decorator="['nodeName', {rules:[{required: true, message: '节点名称不能为空'}]}]"
                           placeholder="请输入"/>
                </a-form-item>
                <a-form-item label="描述">
                  <a-textarea v-decorator="['nodeDescription', {initialValue: 0}]"></a-textarea>
                </a-form-item>
                <a-form-item label="审批方式" required>
                  <a-radio-group
                    v-decorator="['nodeExamineType', {initialValue: 1,rules:[{required: true, message: '不能为空'}]}]">
                    <a-radio :value="1" :style="radioStyle">会签 (可同时审批，每个人必须审批通过)</a-radio>
                    <a-radio :value="2" :style="radioStyle">或签 (有一人审批通过即可)</a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-form>
            </a-tab-pane>
            <a-tab-pane key="2" tab="审核人员" force-render>
              <div class="table-operation-area">
                <div class="btn-area-inline">人员查询</div>
                <a-form
                  class="search-form"
                  layout="inline"
                  :form="listSearchForm"
                  @submit.prevent="handleSearchList"
                >
                  <a-form-item>
                    <a-input
                      style="width: 180px"
                      type="text"
                      v-decorator="['name']"
                      :placeholder="'请输入人员姓名'"
                    >
                      <a-icon
                        slot="prefix"
                        type="search"
                        style="color:rgba(0,0,0,.25)"
                      />
                    </a-input>
                  </a-form-item>

                  <a-form-item style="margin-right:0">
                    <a-button type="primary" html-type="submit" style="margin-right: 10px">
                      {{ $t('visitorMana.reserved.searchBtn') }}
                    </a-button>
                  </a-form-item>
                </a-form>
                <!-- 列表 -->
                <a-table
                  :style="{width: '100%'}"
                  :columns="peopleColumns"
                  :dataSource="peopleList"
                  :pagination="true"
                  :loading="peopleSearchLoading"
                  :rowKey="record=>record.id"
                  :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                >
                  <template slot="name" slot-scope="text, record">
                        <span @click="peopleRowClick(record)" style="display: inline-block; width: 100%; height: 100%">{{
                            text
                          }}</span>
                  </template>
                </a-table>
              </div>
            </a-tab-pane>
            <a-tab-pane key="3" tab="抄送人员" force-render>
              <div class="table-operation-area">
                <div class="btn-area-inline">人员查询</div>
                <a-form
                  class="search-form"
                  layout="inline"
                  :form="listSearchForm1"
                  @submit.prevent="handleSearchList1"
                >
                  <a-form-item>
                    <a-input
                      style="width: 180px"
                      type="text"
                      v-decorator="['name']"
                      :placeholder="'请输入人员姓名'"
                    >
                      <a-icon
                        slot="prefix"
                        type="search"
                        style="color:rgba(0,0,0,.25)"
                      />
                    </a-input>
                  </a-form-item>

                  <a-form-item style="margin-right:0">
                    <a-button type="primary" html-type="submit" style="margin-right: 10px">
                      {{ $t('visitorMana.reserved.searchBtn') }}
                    </a-button>
                  </a-form-item>
                </a-form>
                <!-- 列表 -->
                <a-table
                  :style="{width: '100%'}"
                  :columns="peopleColumns1"
                  :dataSource="peopleList1"
                  :pagination="true"
                  :loading="peopleSearchLoading"
                  :rowKey="record=>record.id"
                  :row-selection="{ selectedRowKeys: selectedRowKeys1, onChange: onSelectChange1 }"
                >
                  <template slot="name" slot-scope="text, record">
                        <span @click="peopleRowClick1(record)" style="display: inline-block; width: 100%; height: 100%">{{
                            text
                          }}</span>
                  </template>
                </a-table>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button :style="{ marginRight: '8px' }" @click="onPeopleSearchClose"> 取消</a-button>
        <a-button type="primary" @click="onPeopleSearchSubmit">保存</a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import ElementUI from 'element-ui'  //引入element-ui库
import { setUserConfig } from '@/api/userMana'
import WorkFlowModal from './components/WorkFlowModal'
import { listPerson } from '../../api/personalMana'
import {
  createExamineNodeConfig,
  deleteExamineNodeConfig,
  showExamineConfig,
  updateExamineNodeConfig,
  updateExamineNodeConfigOrder
} from '../../api/approveMana'
import { getUserConfig } from '../../api/userMana'
import { mapState } from 'vuex'
import store from '@/store'

const enumsData = store.state.enumsStore.enumsData
console.log(enumsData)
export default {
  name: 'workFlowSettings',
  components: {
    WorkFlowModal,
  },
  data() {
    return {
      modelValue: { nodeConfig: {} },
      listSearchForm: this.$form.createForm(this),
      listSearchForm1: this.$form.createForm(this),
      applyForm: this.$form.createForm(this),
      approveForm: this.$form.createForm(this),
      showFeilongDesigner: false,
      feilongDesignerLoading: false,
      feilongDesignerModel: null,
      headStyle: {
        backgroundColor: 'rgb(87, 106, 149)',
        color: '#FFFFFF',
        fontSize: '16px',
        textAlign: 'center',
        borderTopLeftRadius: '4px',
        borderTopRightRadius: '4px',
      },
      approveHeadStyle: {
        backgroundColor: 'rgb(255, 148, 62)',
        color: '#FFFFFF',
        fontSize: '16px',
        textAlign: 'left',
        borderTopLeftRadius: '4px',
        borderTopRightRadius: '4px',
      },
      copyHeadStyle: {
        backgroundColor: 'rgb(50, 150, 250)',
        color: '#FFFFFF',
        fontSize: '16px',
        textAlign: 'left',
        borderTopLeftRadius: '4px',
        borderTopRightRadius: '4px',
      },
      startBodyStyle: {
        color: '#000000',
        fontSize: '14px',
        padding: '15px'
      },
      selectIndex: 0,
      selectType: 1,
      peopleSearchVisible: false,

      selectedRowKeys: [],
      peopleSearchLoading: false,
      peopleList: [],
      peopleColumns: [{
        title: '姓名',
        dataIndex: 'name',
        scopedSlots: { customRender: 'name' }
      }],
      selectedRowKeys1: [],
      peopleSearchLoading1: false,
      peopleList1: [],
      peopleColumns1: [{
        title: '姓名',
        dataIndex: 'name',
        scopedSlots: { customRender: 'name' }
      }],

      tabIndex: '1',
      tabConfigIndex: '1',
      approveIds: [],// 节点ID集合  按顺序来的
      approveList: [], // 所有节点 包含类型
      approveType: 1,
      approvePeoples:[],
      submitting: false,
      form1Submitting: false,
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      examineCondition: [
        {
          "code": 1,
          "name": "被拜访人不明确采用流程审核，被拜访人明确自主审核"
        },
        {
          "code": 2,
          "name": "全部通过流程审核"
        },
        {
          "code": 3,
          "name": "设置被拜访人自主审核，其他未设置被拜访人采用流程审核"
        }
      ],
      examineType:[{code:1,name: '自主审核'},{code:2,name: '流程审核'}],
      configParam:{}
    }
  },
  computed: {
    ...mapState({
      lang: 'lang',
      beVisitedPersonMatchType: state => state.enumsStore.enumsData.beVisitedPersonMatchType,

    })
  },
  created() {
    this.getSettings()
    this.getAllPeoples()
    this.getApproveList()
  },
  deactivated() {
    // this.form.resetFields()
  },
  methods: {
    // 获取设置
    async getSettings() {
      let _this = this
      try {
        const res = await getUserConfig()
        const {
          appointmentApplyExamineType,
          appointmentApplyExamineCondition,
          appointmentApplySelfExaminePersonIds,
          appointmentApplyBeVisitedPersonMatchType,
        } = res.data.collection[0]
        _this.settings = res.data.collection[0]

        let ids  = JSON.parse(appointmentApplySelfExaminePersonIds) || []
        let type = parseInt(appointmentApplyExamineType) || 1
        let param = {appointmentApplyExamineType: type}
        let condition = parseInt(appointmentApplyExamineCondition)
        let matchType = parseInt(appointmentApplyBeVisitedPersonMatchType)
        if ( type === 2){
          param = Object.assign(param,{
            appointmentApplyExamineCondition: condition,
            appointmentApplySelfExaminePersonIds: ids,
            appointmentApplyBeVisitedPersonMatchType: matchType,
          })
        }
        this.configParam = param
        _this.approveType = type
        // 修改 form 初始值
        _this.$nextTick(() => {
          _this.approveForm.setFieldsValue(param)
        })
      } catch (error) {
      }
    },
    addNode(type, index) {
      this.selectIndex = index
      this.selectType = type
      //先弹出侧面信息栏  找到人员数组 基本信息
      // 保存成功后，加入到列表种
      this.handlePeopleSearchShow()
    },
    handlePeopleSearchShow(mdl = null) {
      let _this = this
      if (mdl) {
        let rowKeys = []
        let rowKeys1 = []
        let arr = mdl.type === 1 ? mdl.info.examinePeople : mdl.info.ccPeople
        mdl.info.examinePeople.forEach(item => {
          rowKeys.push(item.id)
        })
        mdl.info.ccPeople.forEach(item => {
          rowKeys1.push(item.id)
        })
        _this.selectedRowKeys = rowKeys
        _this.selectedRowKeys1 = rowKeys1
        this.$nextTick(() => {
          setTimeout(() => {
            this.applyForm.setFieldsValue({
              id: mdl.info.id,
              nodeDescription: mdl.info.nodeDescription,
              nodeExamineType: mdl.info.nodeExamineType,
              nodeName: mdl.info.nodeName,
            })
          }, 200)
        })
      }
      this.getListData('')
      this.getListData1('')
      this.peopleSearchVisible = true
    },
    onPeopleSearchClose() {
      this.peopleSearchVisible = false
      this.applyForm.resetFields()
      this.selectedRowKeys = []
      this.selectedRowKeys1 = []
    },
    getApproveList() {
      let _this = this
      showExamineConfig().then(res => {
        if (res) {
          let list = res.data.collection
          if (list.length > 0) {
            let params = []
            let ids = []
            for (let i = 0; i < list.length; i++) {
              let item = list[i]
              let param = {}
              // 抄送
              let type = 1
              if (item.ccPeople.length > 0 && item.examinePeople.length === 0) {
                type = 2
              }
              if (item.ccPeople.length === 0 && item.examinePeople.length > 0) {
                type = 1
              }
              param.type = type
              param.info = item
              ids.push(item.id)
              params.push(param)
            }
            _this.approveIds = ids
            _this.approveList = params
          }
        }
      })
    },

    // 提交信息
    onPeopleSearchSubmit() {
      let _this = this
      this.applyForm.validateFields((err, val) => {
        if (!err) {
          if (this.selectedRowKeys.length === 0) {
            this.$notification.error({ message: '请选择人员' })
            return
          }
          let data = Object.assign({
            ccPersonIds: this.selectedRowKeys1,
            examinePersonIds: this.selectedRowKeys
          }, val)
          if (data.id) {
            updateExamineNodeConfig(data.id, data).then(res => {
              if (res && res.data.success) {
                _this.onPeopleSearchClose()
                _this.updateConfigOrder()
              }
            })
          } else {
            createExamineNodeConfig(data).then(res => {
              if (res && res.data.success) {
                let id = res.data.collection[0]
                // 将节点键入到列表中  并查询相关顺序
                let ids = _this.approveIds
                ids.splice(_this.selectIndex + 1, 0, id)
                _this.approveIds = ids
                _this.onPeopleSearchClose()
                _this.updateConfigOrder()
              }
            }).catch(() => {
            })
          }
        }else{
          let keys = Object.keys(err)

          keys.forEach(key=>{
            let err1 = err[key].errors
            console.log(err1)
            for (let i = 0; i < err1.length; i++) {
              _this.$notification.error({message: err1[i].message})
            }
          })
        }
      })
    },

    updateConfigOrder() {
      let _this = this
      updateExamineNodeConfigOrder({ nodeConfigIds: _this.approveIds }).then(res => {
        _this.getApproveList()
      })
    },

    deleteConfig(id) {
      let _this = this
      let ids = this.approveIds
      ids = ids.filter((val) => {
        return val !== id
      })
      updateExamineNodeConfigOrder({ nodeConfigIds: ids }).then(res => {
        deleteExamineNodeConfig(id).then(res => {
          _this.getApproveList()
        })
      })
    },
    tabClick(index) {
      this.tabIndex = index
    },
    tabConfigClick(index) {
      this.tabConfigIndex = index
    },
    // 搜索列表
    async handleSearchList() {
      this.listSearchForm.validateFields((err, values) => {
        if (!err) {
          this.getListData(values.name)
        }
      })
    },
    async getListData(name) {
      try {
        this.peopleSearchLoading = true
        const res = await listPerson({ name: name })
        if (res) {
          this.peopleList = res.data.collection
        }
        this.peopleSearchLoading = false
      } catch (err) {
        console.log(err)
        this.$notification.error({message: err})
        this.peopleSearchLoading = false
      }
    },
    // 搜索列表
    async handleSearchList1() {
      this.listSearchForm1.validateFields((err, values) => {
        if (!err) {
          this.getListData1(values.name)
        }
      })
    },
    async getListData1(name) {
      try {
        this.peopleSearchLoading1 = true
        const res = await listPerson({ name: name })
        if (res) {
          this.peopleList1 = res.data.collection
        }
        this.peopleSearchLoading1 = false
      } catch (err) {
        this.$notification.error({message: err})
        this.peopleSearchLoading1 = false
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    onSelectChange1(selectedRowKeys) {
      this.selectedRowKeys1 = selectedRowKeys
    },
    peopleRowClick(rowData) {
      let selectedRowKeys = this.selectedRowKeys
      if (selectedRowKeys.includes(rowData.id)) {
        selectedRowKeys = selectedRowKeys.filter(item => item !== rowData.id)
      } else {
        selectedRowKeys.push(rowData.id)
      }
      this.selectedRowKeys = selectedRowKeys
    },
    peopleRowClick1(rowData) {
      let selectedRowKeys = this.selectedRowKeys1
      if (selectedRowKeys.includes(rowData.id)) {
        selectedRowKeys = selectedRowKeys.filter(item => item !== rowData.id)
      } else {
        selectedRowKeys.push(rowData.id)
      }
      this.selectedRowKeys1 = selectedRowKeys
    },
    getNames(arr) {
      let names = []
      if (arr && arr.length > 0) {
        arr.forEach(item => {
          names.push(item.name)
        })
      }
      return names.length>0 ? names.join('，') :'无'
    },
    async getAllPeoples(){
      let data = []
      try {
        const res = await listPerson({ name: name })
        if (res) {
          data = res.data.collection
        }
      }catch (e){}
      this.approvePeoples = data
    },
    handleApproveSubmit(){
      this.approveForm.validateFields(async (err, values) => {
        // console.log('-----handleSubmit err-----', err)
        // console.log('-----handleSubmit values-----', values)
        if (!err) {
          try {
            this.form1Submitting = true
            await setUserConfig({
              key: 'appointmentApplyExamineType',
              value: values.appointmentApplyExamineType
            })
            if ( this.approveType === 2 ) {
              await setUserConfig({
                key: 'appointmentApplyExamineCondition',
                value: values.appointmentApplyExamineCondition
              })
              // await setUserConfig({
              //   key: 'appointmentApplyBeVisitedPersonMatchType',
              //   value: values.appointmentApplyBeVisitedPersonMatchType
              // })
              if ( this.configParam.appointmentApplyExamineCondition === 3){
                await setUserConfig({
                  key: 'appointmentApplySelfExaminePersonIds',
                  value: values.appointmentApplySelfExaminePersonIds
                })
              }

            }
            this.form1Submitting = false
            this.$notification.success({
              message: '审批设置成功',
              description: ''
            })
          } catch (error) {
            this.form1Submitting = false
          }
        }else{
          console.log(err)
        }
      })
    },
    onApproveTypeChange(e){
      this.approveType = e.target.value
      // console.log(this.configParam)
      // if (e.target.value == 2 && JSON.stringify(this.configParam) !== '{}'){
      //   this.$nextTick(() => {
      //     this.approveForm.setFieldsValue(this.configParam)
      //   })
      // }
      this.approveForm.setFieldsValue({'appointmentApplyExamineType': this.approveType})
    },
    onExamineConditionChange(e) {
      this.configParam.appointmentApplyExamineCondition = e

      // this.$nextTick(() => {
      //   this.approveForm.setFieldsValue(this.configParam)
      // })
      /* "1: 被拜访人不明确采用流程审核，被拜访人明确自主审核"
         "2:全部通过流程审核"
         "3: 设置被拜访人自主审核，其他未设置被拜访人采用流程审核"*/

      //条件1 手机号或者姓名二选一，必须正确
      //条件2  不需要验证策略及 ，手机号必填
      //条件3 手机号必填
      //不需要
    }
  }
}
</script>

<style scoped>
.upload-image-tip {
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 5px;
  color: rgba(0, 0, 0, 0.45);
}

.start-node {
  background-color: rgb(87, 106, 149);
  font-size: 24px;
  padding: 10px 20px;
}

.ant-card-head .ant-card-head-wrapper {
  text-align: center;
}

.card-style {
  width: 300px;
  border-radius: 4px;
}

.node-wrap-box-card {
  width: 300px;
  border-radius: 4px;
  cursor: pointer;
}

.node-wrap-box:hover:after {
  border: 2px solid #3296fa;
  box-shadow: 0 0 6px 0 rgba(50, 150, 250, 0.3);
}

.node-wrap-box:hover .close {
  display: block;
}

.add-node-btn-box {
  width: 300px;
  display: inline-flex;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

.add-node-btn-box:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0px;
  z-index: -1;
  margin: auto;
  width: 2px;
  height: 100%;
  background-color: rgb(202, 202, 202);
}

.add-node-btn {
  user-select: none;
  width: 240px;
  padding: 20px 0 32px;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  flex-grow: 1;
}

.close {
  position: absolute;
  right: 10px;
  font-size: 16px;
  color: #fffdfb;
  transform: translateY(-50%);
  display: none;
}

.node-wrap-box-card:hover .close {
  display: block;
}

.end-node {
  border-radius: 50%;
  font-size: 14px;
  color: #191f2566;
  text-align: left
}

.end-node-circle {
  width: 10px;
  height: 10px;
  margin: auto;
  border-radius: 50%;
  background: #ccc
}

.end-node-text {
  margin-top: 5px;
  text-align: center
}

.add-node-popover-body {
}

.add-node-popover-body li {
  display: inline-block;
  width: 80px;
  text-align: center;
  padding: 10px 0;
}

.add-node-popover-body li i {
  border: 1px solid #e4e7ed;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  text-align: center;
  line-height: 38px;
  font-size: 18px;
  cursor: pointer;
}

.add-node-popover-body li i:hover {
  border: 1px solid #3296fa;
  background: #3296fa;
  color: #fff !important;
}

.add-node-popover-body li p {
  font-size: 12px;
  margin-top: 5px;
}
</style>
